import { PriceCalculationOptions } from '../types/price';

export const calculatePrice = ({ state, prices }: PriceCalculationOptions) => {
	let price = 0;

	for (let i = 0; i < state.sections.length; i++) {
		const section = state.sections[i];
		const key = `${state.material}_${section.height}_${section.depth}`;
		const beamPrice = prices.beams[key] || 0;

		if (state.wallMounted) {
			price += beamPrice;

			if (i === 0) {
				price += beamPrice;
			}
		} else {
			price += beamPrice * 2;
		}

		for (const self of section.selfs) {
			const key = `${self.deck}_${section.width}_${section.depth}`;
			const selfPrice = prices.shelves[key] || 0;

			price += selfPrice;
		}
	}

	if (state.doubleSided) {
		price *= 2;
		price += prices.connector;
	}

	return price;
};
